<template>
    <div>
    <div id="checador_div" class="w-100 px-5 py-4">
      <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div class="area">
            <div>
                <label v-html="deglosarEtiqueta()"></label>
            </div>
            <div class="text-left">
                <button class="btn btn-dark"  @click='volverPreNomina()'>Volver a Pre-Nómina</button>
            </div>
          </div>
        </div>
        <div id="CalendarioChecador_div" class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
            <div class="area">
                <full-calendar :events="eventosFullCalendar" :config="configuracionFullCalendar" @event-selected="calendarioChecadoClic"></full-calendar>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import enumeraciones from '@/../static/js/enumeraciones'
import comun from '@/../static/js/comun'
import FullCalendar from '@/../static/js/fullcalendar'
import router from '@/router/index'
import api from '@/../static/js/api'
import axios from 'axios'  

export default {
    components: {
        FullCalendar
        },
    props: {
        datos: 
        {
            type: Object,
            default: {}
        },
        registros :
        {
            type: Array,
            default: null
        },
        FechaInicial: "",
        prenomina : {
            type : Boolean,
            default : false
        },
        paginaRetorno: {
            type: Number,
            default: 0
        }
    },
    data() {
      return {
          ChecadoIdCambio: 0,
            FechaDefault: "",
            eventosFullCalendar: [],
            configuracionFullCalendar: {
                defaultDate: this.FechaInicial,
                slotLabelFormat: 'h:mma',
                header: {
                    left: this.prenomina!=false ? '' : 'prev,today,next',
                    center: 'title',
                    right: this.prenomina!=false ? '' : 'month,agendaWeek'
                },
                backgroundColor: '#666462',
                defaultView: 'month',
                editable: false,
                eventMouseover: function (data, event, view) {                
                    var tooltip = '<div class="tooltiptopicevent" style="width:auto;height:auto;background:#212529;position:absolute;z-index:10001;padding:10px 10px 10px 10px ;  line-height: 200%;">' + 'Detalle: <br/>' + data.description + '</div>';
                    $("body").append(tooltip);
                    $(this).mouseover(function (e) {
                        $(this).css('z-index', 10000);
                        $('.tooltiptopicevent').fadeIn('500');
                        $('.tooltiptopicevent').fadeTo('10', 1.9);
                    }).mousemove(function (e) {
                        $('.tooltiptopicevent').css('top', e.pageY + 10);
                        $('.tooltiptopicevent').css('left', e.pageX + 20);
                    });
                },
                eventMouseout: function (data, event, view) {
                  if(event.type=="mouseleave")
                  {
                    $(this).css('z-index', 8);
                    $('.tooltiptopicevent').remove();
                  }
                }
            }
      }
    },
    methods: {
        ObtenerCalendario: function(id)
        {
            var peticion = {
                    "PersonaId": id,
                    "FechaInicial" : this.FechaInicial,
                }
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.SIAP.funcion.EventosCalendarioChecador, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => { 
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                  
                    } else { 
                        this.eventosFullCalendar = respuesta.data.Calendario;
                        }
                        comun.SeEstaCargandoInformacion(false);
                    }
                    ).catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);                
                    });
        },
        deglosarEtiqueta(){
            var etiqueta =  "No. de Nómina: " + this.datos.NumeroNomina + "<br/>" +
                            "Nombre: " + this.datos.NombreCompleto + "<br/>" +
                            "Puesto: " + this.datos.Puesto + "<br/>" +
                            "Área: " + this.datos.Seccion
            return etiqueta;
        },
        volverPreNomina(){
            router.push({name: "PreNomina", params: {ListadoRegistrosChecador: this.registros, fechaRouter: this.FechaInicial, paginaSeleccionada : this.paginaRetorno}});
        },
        ValidarRegistro(id){
            var peticion = {
                    "ChecadoId" : id,
                };
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.SIAP.funcion.ValidaChecado, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => { 
              if(respuesta.data.SiHayError){
                          console.log(respuesta);
                          comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                  
              } 
              else
              { 
                comun.SeEstaCargandoInformacion(false);
                
                var indice = this.eventosFullCalendar.findIndex(e=>e.id==id);
                this.eventosFullCalendar[indice].TipoChecadoId = 1;
                this.eventosFullCalendar[indice].title = "ASISTENCIA";
                this.eventosFullCalendar[indice].backgroundColor ="#2CFF6A";
                var index = this.registros.findIndex(e=>e.Persona.NumeroNomina == this.datos.NumeroNomina);
                var diaevento = this.registros[index].Checados.findIndex(a=>a.RegistroChecadorId==id);
                this.registros[index].Checados.splice(diaevento, 1);
              }
            }
            ).catch(excepcion => {
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
              comun.SeEstaCargandoInformacion(false);                
            });
        },
        calendarioChecadoClic: function (event, jsEvent, view){
          //console.log(event)
          if(event.TipoChecadoId==12)
                    {
                      bootbox.confirm({
                      title: "Mensaje del sistema",
                      message: "Desea Validar el registro de asistencia?",
                      buttons: {
                      cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                        },
                      confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                        }
                      },
                      callback: (respuestaSalir) => {
                        if (respuestaSalir) {
                            this.ValidarRegistro(event.id);
                          }
                        }
                      });
                    }
        }
    },
    mounted(){
        var persona = this.datos.PersonaId;
        this.ObtenerCalendario(persona);
    }
}
</script>
<style>
  .padding-div-low {
    padding-top: 40px;
  }

  .fc-view-container {
    background-color: #f6f6f6;
    color: #343a40;
    border-color: #212529 !important;
  }

  .fc-view table {
    border-color: #212529 !important;
  }

  .fc-axis {
    background-color: #504f54;
    color: white;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  }

  .fc-day-header {
    background-color: #212529 !important;
    color: white;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    padding: .75rem !important;
  }

  .fc-button {
    background-color: whitesmoke !important;
    border: none !important;
    padding: .375rem 1.35rem !important;
    color: #212529 !important;
    display: inline-block !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    font-size: 1rem !important;
    border-radius: .25rem !important;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
  }

  .fc-today {
    background-color: #f2f2f2 !important;
    color: #212529 !important;
  }

  .fc-event {
    background-color: #212529;
    border-color: #32383e;
    color: rgb(5, 5, 5) !important;
    padding: .375rem .375rem !important;
    font-size: .75rem !important;
    border-radius: .25rem !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/SIAP/Checador/Calendario.vue